import React, {useEffect} from 'react';
import {Typography, Card, Row, Col, Tabs, List, Divider, Tag, Button} from 'antd';
import {Helmet} from "react-helmet-async";
import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom';
import ChatPromoBanner from "../Fragments/ChatPromoBanner";

const {Title, Paragraph} = Typography;
const {TabPane} = Tabs;

const rulesData = [
    {
        id: 'definitions',
        title: 'Հիմնական հասկացություններ',
        title_ru: 'Основные понятия',
        color: '#1890ff',
        items: [
            {
                title: 'Գլխավոր ճանապարհ',
                title_ru: 'Главная дорога',
                content: '2.1, 2.3.1-2.3.7 կամ 5.1 նշաններով նշված ճանապարհը հատողի նկատմամբ, կամ կոշտ ծածկույթով ճանապարհը հողայինի նկատմամբ:',
                content_ru: 'Дорога, обозначенная знаками 2.1, 2.3.1-2.3.7 или 5.1, по отношению к пересекаемой, или дорога с твердым покрытием по отношению к грунтовой.'
            },
            {
                title: 'Զիջել ճանապարհը',
                title_ru: 'Уступить дорогу',
                content: 'Պահանջ, որ վարորդը չպետք է շարունակի կամ վերսկսի շարժումը, եթե դա կարող է այլ վարորդներին ստիպել փոխել ուղղությունը կամ արագությունը:',
                content_ru: 'Требование, означающее, что водитель не должен продолжать или возобновлять движение, если это может принудить других участников движения изменить направление или скорость.'
            },
            {
                title: 'Վազանց',
                title_ru: 'Обгон',
                content: 'Շարժման մեջ գտնվող մեկ կամ մի քանի տրանսպորտային միջոցից առաջ անցնելը՝ կապված զբաղեցրած գոտուց դուրս գալու հետ:',
                content_ru: 'Опережение одного или нескольких транспортных средств, связанное с выездом из занимаемой полосы.'
            },
            {
                title: 'Կազմակերպված շարասյուն',
                title_ru: 'Организованная колонна',
                content: 'Առնվազն 3 մեխանիկական ՏՄ-ների խումբ, որն ուղեկցվում է կապույտ և կարմիր առկայծող փարոսիկներ միացրած ՏՄ-ով:',
                content_ru: 'Группа из трех и более механических ТС, следующая непосредственно друг за другом с включенными фарами в сопровождении ТС с синим и красным маячками.'
            }
        ]
    },
    {
        id: 'signals',
        title: 'Լուսացույց և Կարգավորող',
        title_ru: 'Светофор и Регулировщик',
        color: '#722ed1',
        items: [
            {
                title: 'Կանաչ թարթող ազդանշան',
                title_ru: 'Зеленый мигающий сигнал',
                content: 'Թույլատրում է երթևեկությունը և տեղեկացնում, որ շուտով կմիանա արգելող ազդանշանը:',
                content_ru: 'Разрешает движение и информирует, что время его действия истекает и вскоре будет включен запрещающий сигнал.'
            },
            {
                title: 'Դեղին թարթող ազդանշան',
                title_ru: 'Желтый мигающий сигнал',
                content: 'Թույլատրում է երթևեկությունը և տեղեկացնում չկարգավորվող խաչմերուկի կամ վտանգի մասին:',
                content_ru: 'Разрешает движение и информирует о наличии нерегулируемого перекрестка или пешеходного перехода, предупреждает об опасности.'
            },
            {
                title: 'Կարգավորող. Ձեռքը վերև',
                title_ru: 'Регулировщик: рука поднята вверх',
                content: 'Տրանսպորտային միջոցների երթևեկությունը և հետիոտների տեղաշարժն արգելված է բոլոր ուղղություններով:',
                content_ru: 'Движение всех транспортных средств и пешеходов запрещено во всех направлениях.'
            },
            {
                title: 'Կարգավորող. Ձեռքերը կողմ',
                title_ru: 'Регулировщик: руки в стороны',
                content: 'Ձախ և աջ կողմերից թույլատրվում է ուղիղ և դեպի աջ: Կրծքի և թիկունքի կողմից երթևեկությունն արգելված է:',
                content_ru: 'Со стороны левого и правого бока разрешено движение прямо и направо. Со стороны груди и спины движение запрещено.'
            }
        ]
    },
    {
        id: 'intersections',
        title: 'Խաչմերուկների անցում',
        title_ru: 'Проезд перекрестков',
        color: '#52c41a',
        items: [
            {
                title: 'Հավասարազոր խաչմերուկ',
                title_ru: 'Равнозначный перекресток',
                content: 'Հավասարազոր ճանապարհների խաչմերուկում վարորդը պարտավոր է ճանապարհը զիջել աջից մոտեցող տրանսպորտային միջոցներին:',
                content_ru: 'На перекрестке равнозначных дорог водитель обязан уступить дорогу транспортным средствам, приближающимся справа.'
            },
            {
                title: 'Ձախ շրջադարձ և հետադարձ',
                title_ru: 'Поворот налево и разворот',
                content: 'Վարորդը պարտավոր է ճանապարհը զիջել հանդիպակաց ուղղությամբ ուղիղ կամ դեպի աջ ընթացող տրանսպորտային միջոցներին:',
                content_ru: 'При повороте налево или развороте водитель обязан уступить дорогу ТС, движущимся со встречного направления прямо или направо.'
            },
            {
                title: 'Շրջանաձև երթևեկություն',
                title_ru: 'Круговое движение',
                content: '4.3 նշանով խաչմերուկ մուտք գործելիս վարորդը պարտավոր է զիջել արդեն շրջանաձև հատվածում գտնվողներին:',
                content_ru: 'При въезде на перекресток с круговым движением (знак 4.3) водитель обязан уступить дорогу ТС, движущимся по такому перекрестку.'
            },
            {
                title: 'Լրացուցիչ սեկցիա',
                title_ru: 'Дополнительная секция',
                content: 'Կարմիր կամ դեղին ազդանշանի հետ միացված սլաքի ուղղությամբ երթևեկողը պետք է զիջի այլ ուղղություններից եկողներին:',
                content_ru: 'Двигаясь в направлении стрелки, включенной одновременно с красным или желтым сигналом, водитель обязан уступить дорогу ТС, движущимся с других направлений.'
            }
        ]
    },
    {
        id: 'speed',
        title: 'Արագության սահմանափակումներ',
        title_ru: 'Скоростные ограничения',
        color: '#f5222d',
        items: [
            {
                title: 'Բնակավայրերում',
                title_ru: 'В населенных пунктах',
                content: 'Տրանսպորտային միջոցների երթևեկությունը թույլատրվում է 60 կմ/ժ-ից ոչ ավելի արագությամբ:',
                content_ru: 'В населенных пунктах разрешается движение транспортных средств со скоростью не более 60 км/ч.'
            },
            {
                title: 'Բնակելի գոտիներում',
                title_ru: 'В жилых зонах',
                content: 'Բնակելի գոտիներում և բակային տարածքներում երթևեկությունը թույլատրվում է 20 կմ/ժ-ից ոչ ավելի:',
                content_ru: 'В жилых зонах и на дворовых территориях скорость движения не должна превышать 20 км/ч.'
            },
            {
                title: 'Բնակավայրերից դուրս',
                title_ru: 'Вне населенных пунктов',
                content: 'Թեթև մարդատար ավտոմոբիլների համար՝ 90 կմ/ժ, իսկ ավտոմայրուղիներում՝ 110 կմ/ժ:',
                content_ru: 'Для легковых автомобилей вне населенных пунктов — 90 км/ч, на автомагистралях — 110 км/ч.'
            },
            {
                title: 'Քարշակման ժամանակ',
                title_ru: 'При буксировке',
                content: 'Մեխանիկական տրանսպորտային միջոցներ քարշակելիս արագությունը չպետք է գերազանցի 50 կմ/ժ-ը:',
                content_ru: 'При буксировке механических транспортных средств скорость не должна превышать 50 км/ч.'
            }
        ]
    },
    {
        id: 'parking',
        title: 'Կանգառ և կայանում',
        title_ru: 'Остановка и стоянка',
        color: '#faad14',
        items: [
            {
                title: 'Արգելված վայրեր',
                title_ru: 'Запрещенные места',
                content: 'Թունելներում, կամուրջների, էստակադների վրա և դրանց տակ, երկաթուղային գծանցներում, հետիոտնային անցումների վրա:',
                content_ru: 'В тоннелях, на мостах, эстакадах и под ними, на ж/д переездах, на пешеходных переходах.'
            },
            {
                title: 'Տեսանելիություն',
                title_ru: 'Видимость',
                content: 'Արգելվում է ճանապարհի այն հատվածներում, որտեղ տեսանելիությունը թեկուզ մեկ ուղղությամբ պակաս է 100 մետրից:',
                content_ru: 'Запрещается в местах с видимостью дороги менее 100 м хотя бы в одном направлении.'
            },
            {
                title: 'Երկաթուղային գծանց',
                title_ru: 'Ж/Д переезд',
                content: 'Կայանումն արգելվում է երկաթուղային գծանցներից 50 մետրից պակաս հեռավորության վրա:',
                content_ru: 'Стоянка запрещена ближе 50 м от железнодорожных переездов.'
            }
        ]
    },
    {
        id: 'technical',
        title: 'Շահագործման արգելքներ',
        title_ru: 'Техническое состояние',
        color: '#eb2f96',
        items: [
            {
                title: 'Ղեկային կառավարում',
                title_ru: 'Рулевое управление',
                content: 'Խաղացքը (люфт) չպետք է գերազանցի 10° (թեթև մարդատար), 20° (ավտոբուս) կամ 25° (բեռնատար) աստիճանը:',
                content_ru: 'Суммарный люфт не должен превышать 10° (легковые), 20° (автобусы) или 25° (грузовые).'
            },
            {
                title: 'Անվադողեր',
                title_ru: 'Шины',
                content: 'Պահպանաշերտի բարձրությունը՝ ավտոբուս (2.0մմ), թեթև մարդատար (1.6մմ), բեռնատար (1.0մմ), մոտոցիկլ (0.8մմ):',
                content_ru: 'Остаточная высота протектора: автобусы (2.0мм), легковые (1.6мм), грузовые (1.0мм), мотоциклы (0.8мм).'
            },
            {
                title: 'Արտաքին լույսեր',
                title_ru: 'Внешние световые приборы',
                content: 'Առջևում՝ սպիտակ, դեղին կամ նարնջագույն: Հետևում՝ հետընթացի և համարանիշի լույսերը միայն սպիտակ:',
                content_ru: 'Спереди: белый, желтый или оранжевый. Сзади: фонари заднего хода и освещения номера — только белые.'
            },
            {
                title: 'Արգելակային համակարգ',
                title_ru: 'Тормозная система',
                content: 'Արգելվում է, եթե խախտված է հերմետիկությունը կամ կայանման արգելակը չի պահում սահմանված թեքության վրա:',
                content_ru: 'Запрещается при нарушении герметичности или если стояночный тормоз не удерживает ТС на уклоне.'
            }
        ]
    },
    {
        id: 'vehicle_signs',
        title: 'Ճանաչման նշաններ',
        title_ru: 'Опознавательные знаки',
        color: '#13c2c2',
        items: [
            {
                title: 'Երեխաների փոխադրում',
                title_ru: 'Перевозка детей',
                content: 'Դեղին քառակուսի՝ կարմիր պարզած ուղղանկյունով և վազող երեխաների պատկերով:',
                content_ru: 'Желтый квадрат с красной каймой и изображением бегущих детей.'
            },
            {
                title: 'Վտանգավոր բեռ',
                title_ru: 'Опасный груз',
                content: 'Նարնջագույն ուղղանկյուն, որի վրա նշվում են բեռի վտանգավորության բնութագրերը:',
                content_ru: 'Оранжевый прямоугольник с обозначением класса опасности груза.'
            },
            {
                title: 'Ուսումնական ՏՄ',
                title_ru: 'Учебное ТС',
                content: 'Սպիտակ հավասարակողմ եռանկյուն՝ կարմիր պարզած ուղղանկյունով և սև «Ու» («У») տառով:',
                content_ru: 'Белый равносторонний треугольник с красной каймой и буквой «У» черного цвета.'
            },
            {
                title: 'Խուլ վարորդ',
                title_ru: 'Глухой водитель',
                content: '160մմ տրամագծով դեղին շրջան՝ ներսում 3 սև շրջանակներով:',
                content_ru: 'Желтый круг диаметром 160 мм с тремя черными кружками внутри.'
            }
        ]
    },
    {
        id: 'firstaid',
        title: 'Առաջին օգնություն',
        title_ru: 'Первая помощь',
        color: '#2f54eb',
        items: [
            {
                title: 'Զարկերակային արյունահոսություն',
                title_ru: 'Артериальное кровотечение',
                content: 'Արյունը վառ կարմիր է, բխում է շիթով։ Անհրաժեշտ է սեղմել զարկերակը և վերքից վերև դնել լարան:',
                content_ru: 'Кровь ярко-алого цвета, пульсирует струей. Необходимо прижать артерию и наложить жгут выше раны.'
            },
            {
                title: 'Երակային արյունահոսություն',
                title_ru: 'Венозное кровотечение',
                content: 'Արյունը մուգ կարմիր է, հոսում է միալար։ Անհրաժեշտ է դնել ճնշող վիրակապ անմիջապես վերքի վրա:',
                content_ru: 'Кровь темно-вишневого цвета, течет непрерывно. Необходимо наложить давящую повязку.'
            },
            {
                title: 'Ողնաշարի վնասվածք',
                title_ru: 'Травма позвоночника',
                content: 'Տուժածին չի կարելի տեղաշարժել կամ փոխել դիրքը մինչև մասնագետների ժամանումը:',
                content_ru: 'Пострадавшего нельзя перемещать или менять его позу до прибытия медиков.'
            }
        ]
    }
];

const LearnRules = ({analytics}) => {
    const {t, i18n} = useTranslation();
    const isRu = i18n.language === 'ru';

    useEffect(() => {
        if (analytics) analytics();
    }, [analytics]);

    return (
        <div style={{padding: '20px', maxWidth: '1200px', margin: '0 auto'}}>
            <Helmet>
                <title>{t('seo.learn_title')}</title>
                <meta name="description" content={t('seo.learn_desc')} />
                <meta property="og:title" content={t('seo.learn_title')} />
                <meta property="og:description" content={t('seo.learn_desc')} />
            </Helmet>


            
            <Row gutter={[24, 24]}>
                <Col span={24}>
                    <div style={{textAlign: 'center', marginBottom: '40px'}}>
                        <Title level={1}>
                            {isRu ? 'Правила дорожного движения' : 'Ճանապարհային երթևեկության կանոններ'}
                        </Title>
                        <Paragraph style={{fontSize: '18px', color: '#595959'}}>
                            {isRu 
                                ? 'Здесь собраны самые важные и часто встречающиеся правила для сдачи экзамена на водительские права'
                                : 'Այստեղ հավաքված են վարորդական քննության համար ամենակարևոր և հաճախ հանդիպող կանոնները'
                            }
                        </Paragraph>
                    </div>
                </Col>
            </Row>

            <Tabs defaultActiveKey="definitions" type="card" size="large">
                {rulesData.map(category => (
                    <TabPane 
                        tab={
                            <span>
                                <Tag color={category.color} style={{borderRadius: '4px', marginRight: '8px'}} />
                                {isRu ? category.title_ru : category.title}
                            </span>
                        } 
                        key={category.id}
                    >
                        <div style={{padding: '20px', background: '#fff', borderRadius: '0 0 8px 8px', border: '1px solid #f0f0f0', borderTop: 'none'}}>
                            <Title level={3} style={{color: category.color, borderBottom: `2px solid ${category.color}`, paddingBottom: '10px', marginBottom: '30px'}}>
                                {isRu ? category.title_ru : category.title}
                            </Title>
                            
                            <List
                                grid={{ gutter: 24, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
                                dataSource={category.items}
                                renderItem={item => (
                                    <List.Item>
                                        <Card 
                                            title={<Title level={4} style={{margin: 0, fontSize: '18px'}}>{isRu ? item.title_ru : item.title}</Title>}
                                            bordered={false}
                                            style={{
                                                height: '100%', 
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                                borderLeft: `4px solid ${category.color}`,
                                                borderRadius: '8px'
                                            }}
                                        >
                                            <Paragraph style={{fontSize: '16px', lineHeight: '1.6', margin: 0}}>
                                                {isRu ? item.content_ru : item.content}
                                            </Paragraph>
                                        </Card>
                                    </List.Item>
                                )}
                            />
                        </div>
                    </TabPane>
                ))}
            </Tabs>

            <Divider style={{margin: '60px 0 40px'}} />
            
            <Row justify="center">
                <Col span={24} style={{textAlign: 'center'}}>
                    <Title level={4}>
                        {isRu ? 'Готовы проверить свои знания?' : 'Պատրա՞ստ եք ստուգել ձեր գիտելիքները'}
                    </Title>
                    <Paragraph>
                        {isRu 
                            ? 'Перейдите в раздел тестов и начните решение экзаменационных билетов'
                            : 'Անցեք թեստեր բաժինը և սկսեք քննական հարցաշարերի լուծումը'
                        }
                    </Paragraph>
                    <Link to="/quizes">
                        <Button type="primary" size="large" style={{borderRadius: '8px', height: 'auto', padding: '10px 40px'}}>
                            {isRu ? 'Перейти к тестам' : 'Անցնել Թեստերին'}
                        </Button>
                    </Link>
                </Col>
            </Row>
        </div>
    );
};

export default LearnRules;
